import AXIOS from './axios-wrapper';
import {ARTICLE_PROJETION, BOARD_ID, SORT_ASC_DESC, SORT_FIELD} from '@/util/BoardConst';
import {BoardArticle, BoardArticleResponse, BoardInfo} from '@/models';
import {BOARD_ID_PKG, BOARD_ID_PKG_NEW} from '@/pages/ReservePage/API/hotelBoardID';

export class BoardParam {
  bid!: BOARD_ID;
  pageNumber = 1;
  pageSize = 10;
  aProjection: ARTICLE_PROJETION = 'BoardArticleDetailWithFiles';
  sortField: SORT_FIELD = 'id';
  sortAscDesc: SORT_ASC_DESC = 'desc';
  isView = true;
  subtitle1Search = '';

  constructor(bid: BOARD_ID) {
    this.bid = bid;
  }
}

class BoardService {
  constructor() {
    console.log('creating new instance of BoardService');
  }

  // BOARD API

  async getBoardInfo(bid: BOARD_ID): Promise<BoardInfo> {
    const response = await AXIOS.get<BoardInfo>(`/BoardInfoRepo/${bid}`);
    return response.data;
  }

  async getArticleList(
    bid: BOARD_ID,
    pageNumber = 1,
    pageSize = 10,
    aProjection: ARTICLE_PROJETION = 'BoardArticleSummary',
    sortField: SORT_FIELD = 'id',
    sortAscDesc: SORT_ASC_DESC = 'desc',
    isView = true,
    subtitle1Search = '',
  ): Promise<BoardArticleResponse> {
    let req_uri = `/BoardArticleRepo?projection=${aProjection}&boardInfo.id=${bid}&isView=${isView}&page=${
      pageNumber - 1
    }&size=${pageSize}&sort=${sortField},${sortAscDesc}`;
    if (subtitle1Search) {
      req_uri += `&subtitle1=${subtitle1Search}`;
    }

    const response = await AXIOS.get<BoardArticleResponse>(req_uri);
    return response.data;
  }
  async getArticleListByid(
    bid: BOARD_ID,
    pageNumber = 1,
    pageSize = 10,
    aProjection: ARTICLE_PROJETION = 'BoardArticleSummary',
    sortField: SORT_FIELD = 'id',
    sortAscDesc: SORT_ASC_DESC = 'desc',
    isView = true,
    articleId = 0,
  ): Promise<BoardArticleResponse> {
    let req_uri = `/BoardArticleRepo?projection=${aProjection}&boardInfo.id=${bid}&isView=${isView}&page=${
      pageNumber - 1
    }&size=${pageSize}&sort=${sortField},${sortAscDesc}`;
    if (articleId > 0) {
      req_uri += `&id=${articleId}`;
    }

    const response = await AXIOS.get<BoardArticleResponse>(req_uri);
    return response.data;
  }
  async getArticleListWithMemo(
    bid: BOARD_ID,
    pageNumber = 1,
    pageSize = 10,
    aProjection: ARTICLE_PROJETION = 'BoardArticleSummaryWithMemo',
    sortField: SORT_FIELD = 'id',
    sortAscDesc: SORT_ASC_DESC = 'desc',
    isView = true,
    subtitle1Search = '',
  ): Promise<BoardArticleResponse> {
    let req_uri = `/BoardArticleRepo?projection=${aProjection}&boardInfo.id=${bid}&isView=${isView}&page=${
      pageNumber - 1
    }&size=${pageSize}&sort=${sortField},${sortAscDesc}`;
    if (subtitle1Search) {
      req_uri += `&subtitle1=${subtitle1Search}`;
    }
    if (bid === BOARD_ID_PKG_NEW || bid === BOARD_ID_PKG) {
      req_uri += `&pkgSaleType=10,null`;
    }

    const response = await AXIOS.get<BoardArticleResponse>(req_uri);
    return response.data;
  }

  async getArticleList5(
    bid: BOARD_ID,
    pageNumber = 1,
    pageSize = 10,
    aProjection: ARTICLE_PROJETION = 'BoardArticleSummary',
    sortField: SORT_FIELD = 'id',
    sortAscDesc: SORT_ASC_DESC = 'desc',
    isView = true,
    subtitle5Search = '',
  ): Promise<BoardArticleResponse> {
    let req_uri = `/BoardArticleRepo?projection=${aProjection}&boardInfo.id=${bid}&isView=${isView}&page=${
      pageNumber - 1
    }&size=${pageSize}&sort=${sortField},${sortAscDesc}`;
    if (subtitle5Search) {
      req_uri += `&subtitle5=${subtitle5Search}`;
    }

    const response = await AXIOS.get<BoardArticleResponse>(req_uri);
    return response.data;
  }

  async getArticleListObjParam(p: BoardParam): Promise<BoardArticle[]> {
    const list = await this.getArticleList(
      p.bid,
      p.pageNumber,
      p.pageSize,
      p.aProjection,
      p.sortField,
      p.sortAscDesc,
      p.isView,
      p.subtitle1Search,
    );
    return list._embedded.boardArticles.map(x => new BoardArticle(x));
  }

  async getArticleListObjParamFirst(p: BoardParam): Promise<BoardArticle | null> {
    const result = await this.getArticleList(
      p.bid,
      p.pageNumber,
      p.pageSize,
      p.aProjection,
      p.sortField,
      p.sortAscDesc,
      p.isView,
      p.subtitle1Search,
    );

    if (result._embedded && result._embedded.boardArticles && result._embedded.boardArticles.length > 0)
      return new BoardArticle(result._embedded.boardArticles[0]);

    return null;
  }

  async getArticleById(
    bid: BOARD_ID,
    aProjection: ARTICLE_PROJETION = 'BoardArticleSummary',
    id: number,
  ): Promise<BoardArticleResponse> {
    const req_uri = `/BoardArticleRepo?projection=${aProjection}&boardInfo.id=${bid}&id=${id}`;
    const response = await AXIOS.get<BoardArticleResponse>(req_uri);
    return response.data;
  }

  async getArticleDetails(aid: number): Promise<BoardArticle> {
    const response = await AXIOS.get<BoardArticle>(`/BoardArticleRepo/${aid}?projection=BoardArticleDetail`);

    return response.data;
  }

  // 목록 조회 시 memo를 제외한 게시글의 memo를 필요할 때 조회 (본문에 base64 이미지가 포함되어 용량이 큼)
  async getArticleMemo(article: BoardArticle): Promise<string> {
    if (article.memo || !article.id) return article.memo ?? '';
    const detail = await this.getArticleDetails(article.id);
    article.memo = detail.memo ?? '';
    return article.memo;
  }
}

// Export a singleton instance in the global namespace
const boardService = new BoardService();

export default boardService;
